"use strict";
/*
 *
 *@description:  通用弹窗组件
 *@modifyContent:
 *@author: qiuhongyang
 *@date: 2020-09-22 09:52:23
 *
*/
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dot_1 = __importDefault(require("dot"));
var tpl = require("./toastmodal.html");
require("./style.less");
;
var CommonModal = {
    options: {
        subcallback: Function //提交回调
    },
    init: function (opt) {
        var defaultopt = {
            content: "",
            callback: null,
            showtime: 3000,
            showwarmicon: true,
            width: 298,
            height: 218,
            tipinfos: '',
            subtext: "确定",
            iconname: "icon_sub",
            showsubbtn: true,
            showcancelbtn: true
        };
        this.options = $.extend({}, defaultopt, opt);
        var htmlstr = dot_1.default.template(tpl)(this.options);
        $('body').append($(htmlstr));
        this.bindevent();
    },
    bindevent: function () {
        var that = this;
        $(".modal_shadow").on('click', function () {
            $(".commonmodal").remove();
        });
        $(".sure_btn").on('click', function () {
            var subcallback = that.options.subcallback;
            if (subcallback) {
                subcallback();
            }
            ;
            $(".commonmodal").remove();
            return false;
        });
        $(".modalbtn_cancel").on('click', function () {
            $(".commonmodal").remove();
            return false;
        });
    }
};
exports.default = CommonModal;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG9hc3Rtb2RhbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInRvYXN0bW9kYWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7Ozs7O0VBT0U7Ozs7O0FBR0YsNENBQXNCO0FBQ3RCLElBQUksR0FBRyxHQUFHLE9BQU8sQ0FBQyxtQkFBbUIsQ0FBQyxDQUFDO0FBQ3ZDLHdCQUFzQjtBQUtyQixDQUFDO0FBRUYsSUFBSSxXQUFXLEdBQUc7SUFDZCxPQUFPLEVBQUU7UUFDTCxXQUFXLEVBQUMsUUFBUSxDQUFFLE1BQU07S0FDL0I7SUFDRCxJQUFJLFlBQUMsR0FBUTtRQUNULElBQUksVUFBVSxHQUFHO1lBQ2IsT0FBTyxFQUFFLEVBQUU7WUFDWCxRQUFRLEVBQUUsSUFBSTtZQUNkLFFBQVEsRUFBRSxJQUFJO1lBQ2QsWUFBWSxFQUFFLElBQUk7WUFDbEIsS0FBSyxFQUFFLEdBQUc7WUFDVixNQUFNLEVBQUUsR0FBRztZQUNYLFFBQVEsRUFBRSxFQUFFO1lBQ1osT0FBTyxFQUFDLElBQUk7WUFDWixRQUFRLEVBQUMsVUFBVTtZQUNuQixVQUFVLEVBQUMsSUFBSTtZQUNmLGFBQWEsRUFBQyxJQUFJO1NBRXJCLENBQUM7UUFDRixJQUFJLENBQUMsT0FBTyxHQUFHLENBQUMsQ0FBQyxNQUFNLENBQUMsRUFBRSxFQUFFLFVBQVUsRUFBRSxHQUFHLENBQUMsQ0FBQztRQUU3QyxJQUFJLE9BQU8sR0FBRyxhQUFHLENBQUMsUUFBUSxDQUFDLEdBQUcsQ0FBQyxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsQ0FBQTtRQUU3QyxDQUFDLENBQUMsTUFBTSxDQUFDLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDO1FBQzdCLElBQUksQ0FBQyxTQUFTLEVBQUUsQ0FBQztJQUNyQixDQUFDO0lBQ0QsU0FBUztRQUNMLElBQUksSUFBSSxHQUFHLElBQUksQ0FBQztRQUNoQixDQUFDLENBQUMsZUFBZSxDQUFDLENBQUMsRUFBRSxDQUFDLE9BQU8sRUFBRTtZQUMzQixDQUFDLENBQUMsY0FBYyxDQUFDLENBQUMsTUFBTSxFQUFFLENBQUE7UUFDOUIsQ0FBQyxDQUFDLENBQUE7UUFFRixDQUFDLENBQUMsV0FBVyxDQUFDLENBQUMsRUFBRSxDQUFDLE9BQU8sRUFBRTtZQUN2QixJQUFJLFdBQVcsR0FBRyxJQUFJLENBQUMsT0FBTyxDQUFDLFdBQVcsQ0FBQztZQUMzQyxJQUFJLFdBQVcsRUFBQztnQkFBQyxXQUFXLEVBQUUsQ0FBQTthQUFDO1lBQUEsQ0FBQztZQUNoQyxDQUFDLENBQUMsY0FBYyxDQUFDLENBQUMsTUFBTSxFQUFFLENBQUM7WUFDM0IsT0FBTyxLQUFLLENBQUM7UUFDakIsQ0FBQyxDQUFDLENBQUE7UUFFRixDQUFDLENBQUMsa0JBQWtCLENBQUMsQ0FBQyxFQUFFLENBQUMsT0FBTyxFQUFFO1lBQzlCLENBQUMsQ0FBQyxjQUFjLENBQUMsQ0FBQyxNQUFNLEVBQUUsQ0FBQztZQUMzQixPQUFPLEtBQUssQ0FBQztRQUNqQixDQUFDLENBQUMsQ0FBQTtJQUNOLENBQUM7Q0FDSixDQUFBO0FBSUQsa0JBQWUsV0FBVyxDQUFBIn0=